import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizHtmlEditor from "@/components/quiz/QuizHtmlEditor.vue";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
import axios from "axios";
import { Events } from "@/events/events";
import AxiosUtils from "@/util/axiosUtils";
let QuizQuestionCorrectionEditor = class QuizQuestionCorrectionEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "correction", void 0);
    _defineProperty(this, "realtimeCorrection", '');
  }
  mounted() {
    this.realtimeCorrection = this.correction;
  }
  get editorId() {
    return 'question-correction-text-editor-' + this.questionId;
  }
  get editorConfig() {
    return {
      placeholder: this.$t('chapter.question.correction.placeholder')
    };
  }
  onCorrectionBlur(editorContent) {
    if (editorContent.trim() !== this.realtimeCorrection.trim()) {
      this.realtimeCorrection = editorContent.trim();
      axios.patch(`/api/v2/quiz-questions/${this.questionId}`, {
        questionDataJson: JSON.stringify({
          correction: this.realtimeCorrection
        })
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {
        WElmessage.showSuccessMessage(this.$t('chapter.question.correction.updateSuccessful'));
      }, error => {
        AxiosUtils.displayError(error, this.$t('errors.default'));
      });
    }
  }
  onCloseBtnClick() {
    trig(Events.FIN_EDITION_QUIZZ_CORRECTION);
  }
};
__decorate([Prop({
  required: true
})], QuizQuestionCorrectionEditor.prototype, "questionId", void 0);
__decorate([Prop({
  default: ''
})], QuizQuestionCorrectionEditor.prototype, "correction", void 0);
QuizQuestionCorrectionEditor = __decorate([Component({
  components: {
    QuizHtmlEditor
  }
})], QuizQuestionCorrectionEditor);
export default QuizQuestionCorrectionEditor;